import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "home" };
const _hoisted_2 = { class: "container" };
const _hoisted_3 = { class: "row row-cols-1 row-cols-md-2" };
const _hoisted_4 = {
    key: 0,
    class: "col"
};
const _hoisted_5 = {
    key: 1,
    class: "col"
};
const _hoisted_6 = { class: "row" };
const _hoisted_7 = { class: "col" };
const _hoisted_8 = { class: "row" };
const _hoisted_9 = { class: "col" };
import HomeWelcome from "../components/HomeWelcome.vue";
import HomePendingOrders from "../components/HomePendingOrders.vue";
import HomeOrderUntil from "../components/HomeOrderUntil.vue";
import HomeWatchlists from "../components/HomeWatchlists.vue";
import HomeCatalog from "../components/HomeCatalog.vue";
import HomeSearch from "../components/HomeSearch.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'HomeView',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(HomeWelcome),
                _cache[3] || (_cache[3] = _createTextVNode()),
                (_ctx.$isGranted('PORTAL_CATALOG_VIEW'))
                    ? (_openBlock(), _createBlock(HomeSearch, { key: 0 }))
                    : _createCommentVNode("", true),
                _cache[4] || (_cache[4] = _createTextVNode()),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        (_ctx.$isGranted('PORTAL_ORDERS_CREATE'))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createVNode(HomeOrderUntil)
                            ]))
                            : _createCommentVNode("", true),
                        _cache[0] || (_cache[0] = _createTextVNode()),
                        (_ctx.$isGranted('PORTAL_WATCHLISTS_VIEW'))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _createVNode(HomeWatchlists)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _cache[1] || (_cache[1] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                            (_ctx.$isGranted('PORTAL_ORDERS_VIEW'))
                                ? (_openBlock(), _createBlock(HomePendingOrders, { key: 0 }))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _cache[2] || (_cache[2] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                            (_ctx.$isGranted('PORTAL_CATALOG_VIEW'))
                                ? (_openBlock(), _createBlock(HomeCatalog, { key: 0 }))
                                : _createCommentVNode("", true)
                        ])
                    ])
                ])
            ]));
        };
    }
});
